import { render, staticRenderFns } from "./SinDesglosar.vue?vue&type=template&id=6b8be674&"
import script from "./SinDesglosar.vue?vue&type=script&lang=js&"
export * from "./SinDesglosar.vue?vue&type=script&lang=js&"
import style0 from "./SinDesglosar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports